import {
  FETCH_GRADE_START,
  FETCH_GRADE_SUCCESS,
  FETCH_GRADE_FAILED
} from '../../actionTypes/index.js'

import gradeAxios from '../../../../axios/gradeCriteria'
import { enqueueSnackbar } from '../../../actions/alert'
import { extractRecordsFromResponse } from '../../../../helpers/utils'

export const fetchGrades = filterOptions => {
  return dispatch => {
    dispatch(fetchGradesStart())
    gradeAxios
      .get('', {
        params: filterOptions
      })
      .then(response => {
        if (response.status === 200) {
          const { data, pagination } = extractRecordsFromResponse(response)
          dispatch(fetchGradesSuccess(data, pagination, filterOptions))
        }
      })
      .catch(error => {
        console.log(error, { ...error })
        dispatch(fetchGradesFailed())
        dispatch(
          enqueueSnackbar({
            message: 'Fetch Grade Failed',
            options: { variant: 'error' }
          })
        )
      })
  }
}

const fetchGradesStart = () => {
  return {
    type: FETCH_GRADE_START
  }
}

const fetchGradesSuccess = (records, pagination, filters) => {
  return {
    type: FETCH_GRADE_SUCCESS,
    records,
    pagination,
    filters
  }
}

const fetchGradesFailed = () => {
  return {
    type: FETCH_GRADE_FAILED
  }
}
